import addressLineValidator from './addressLineValidator';
import ageValidator from './ageValidator';
import alphaNoSpaceValidator from './alphaNoSpaceValidator';
import alphaNumericNoSpaceValidator from './alphaNumericNoSpaceValidator';
import alphaValidator from './alphaValidator';
import alphaNumericValidator from './alphaNumericValidator';
import amountValidator from './amountValidator';
import cityValidator from './cityValidator';
import creditCardSecurityCodeValidator from './creditCardSecurityCodeValidator';
import creditCardValidator from './creditCardValidator';
import customRegExValidator from './customRegExValidator';
import dateInPastValidator from './dateInPastValidator';
import dateValidator from './dateValidator';
import emailAddressValidator from './emailAddressValidator';
import equalityValidator from './equalityValidator';
import foreignIDValidator from './foreignIDValidator';
import futureDateValidator from './futureDateValidator';
import futureMonthValidator from './futureMonthValidator';
import ignoreCaseEqualityValidator from './ignoreCaseEqualityValidator';
import lengthValidator from './lengthValidator';
import noWhiteSpaceValidator from './noWhiteSpaceValidator';
import nameOnCardValidator from './nameOnCardValidator';
import numberValidator from './numberValidator';
import passwordEqualityValidator from './passwordEqualityValidator';
import percentageValidator from './percentageValidator';
import phoneValidator from './phoneValidator';
import poBoxValidator from './poBoxValidator';
import requiredValidator from './requiredValidator';
import ssnValidator from './ssnValidator';
import wildCardValidator from './wildCardValidator';
import xssValidator from './xssValidator';
import zipCodeValidator from './zipCodeValidator';
import notEqualityValidator from './notEqualityValidator';
import passcodeValidator from './passcodeValidator';

export default {
  addressLineValidator,
  ageValidator,
  alphaNoSpaceValidator,
  alphaNumericNoSpaceValidator,
  alphaNumericValidator,
  alphaValidator,
  amountValidator,
  cityValidator,
  creditCardSecurityCodeValidator,
  creditCardValidator,
  customRegExValidator,
  dateInPastValidator,
  dateValidator,
  emailAddressValidator,
  equalityValidator,
  foreignIDValidator,
  futureDateValidator,
  futureMonthValidator,
  ignoreCaseEqualityValidator,
  lengthValidator,
  nameOnCardValidator,
  noWhiteSpaceValidator,
  notEqualityValidator,
  numberValidator,
  passcodeValidator,
  passwordEqualityValidator,
  percentageValidator,
  phoneValidator,
  poBoxValidator,
  requiredValidator,
  ssnValidator,
  wildCardValidator,
  xssValidator,
  zipCodeValidator,
};
